import { render, staticRenderFns } from "./LawMatterSubSubjectList.vue?vue&type=template&id=7618336b&"
import script from "./LawMatterSubSubjectList.vue?vue&type=script&lang=js&"
export * from "./LawMatterSubSubjectList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterSubSubjectList.vue?vue&type=style&index=0&id=7618336b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports